<template>
  <div class="flex-box" style="background-color: var(--hduhelp-blue);">
    <div style="padding-bottom: 10vh;">
      <img
        src="../../../public/sticker/loading.png"
        class="center-image special-center-image"
        alt="hduhelper"
      />

      <div>
        <span class="big-font">少女加载中……</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'loading',
}
</script>

<style scoped>
.special-center-image {
  height: 50vh;
  bottom: 20vh;
}

.flex-box {
  display: flex;
  z-index: 10;
  height: 100vh;
  width: 100vw;
  align-items: center;
  justify-content: center;
}
</style>
